import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allMonth,
  formLabelsTheme,
  getValueType,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

import { ThemeProvider } from "@material-ui/core";

export const InboundCopy = ({ isOpen, handleShow, setShow, id, name }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClose = () => setShow(false);

  const [copy, setCopy] = useState("");

  const handleSave = async () => {
    const params = {
      copy: id,
      copy_product_id: copy,
    };
    // try {
    //   const response = await dispatch(duplicateProductMaster(params));
    //   if (response.payload.status === 200) {
    //     const action = await showSuccessDialog(response.payload.data.message);
    //     // if (action.isConfirmed)
    //     //   await history.push(
    //     //     `/master/product-related/product-master/edit/${response.payload.data.data.product_id}`
    //     //   );
    //     setShow(false);
    //   } else {
    //     showErrorDialog(response.payload.data.message);
    //   }
    // } catch (error) {
    //   showErrorDialog(error.message);
    // }
  };

  return (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Copy Job Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <p>
              You are about to copy the inbound job plan No.
              {name}, this task cannot be undone! Are you sure want
              <br />
              to copy this inbound job plan?
            </p>
            <div>
              <Form.Check
                inline
                label="Copy Vehicle Details"
                name="group1"
                type="checkbox"
                className="ml-5 mb-4 mt-4"
                onChange={(e) => {
                  if (e.target.checked === true) {
                    setCopy("Y");
                  } else {
                    setCopy("N");
                  }
                }}
              />
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
